import "../scss/main.scss";

import { OnScroll } from "./onScroll";
import { HeaderSlider } from "./headerSlider";
import { MobileNavigation } from "./mobileNavigation";
import { FoodValueAccordion } from "./foodValueAccordion";

import SlimSelect from "slim-select";
import "../../node_modules/slim-select/dist/slimselect.min.css";

// prevent firefox from caching pages on back button
window.onunload = function () {};

(function () {
	new OnScroll({
		bodyScrollClass: "body--scroll",
	});

	new HeaderSlider({
		el: ".header-slider",
		pagination: ".header-slider__pagination",
		modifierClass: "header-slider__",
		bulletClass: "header-slider__bullet",
		bulletActiveClass: "header-slider__bullet--active",
		currentClass: "header-slider__bullet--current",
	});

	new MobileNavigation({
		el: ".header",
		openedClass: "header--opened",
		burger: ".header__burger",
		searchLink: ".header-navigation__item--search .header-navigation__link",
		search: ".search-modal",
		searchClose: ".search-modal__close",
		searchShowClass: "search-modal--show",
	});

	if (document.querySelector(".product-detail__food-values")) {
		new FoodValueAccordion({
			el: ".product-detail__food-values",
			opener: ".product-detail__food-values-opener",
			openedClass: "product-detail__food-values--opened",
		});
	}

	if (document.querySelector("#sort")) {
		new SlimSelect({
			select: "#sort",
			allowDeselectOption: true,
			showSearch: false,
		});
	}

	if (document.querySelector("#category")) {
		new SlimSelect({
			select: "#category",
			allowDeselectOption: true,
			showSearch: false,
		});
	}
})();
